import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { useMemo } from 'react';

function DashboardDateRange({
  dates,
  onChange,
  emptyLabel,
  optionLabel = undefined,
  showFilter = false,
  showClear = true,
  ...props
}) {
  console.log(dates);
  const isActive = useMemo(() => dates, [dates]);
  return (
    <Calendar
      value={dates}
      onChange={(e) => onChange(e.value)}
      selectionMode="range"
      readOnlyInput
      hideOnRangeSelection
      inputClassName={classNames(`!text-sm !rounded-full !pl-3 w-[200px]`, {
        'active-custom-dropdown': isActive
      })}
      locale="fr"
      showButtonBar={true}
      placeholder={emptyLabel}
    />
  );
}

export default DashboardDateRange;
